export const acquaintanceFormTrackingID = 'dagligbank-acquaintance-form';
